import React from "react";
import { Link } from "react-router-dom";
import InfoPage from "./Infopage";
import { Helmet } from "react-helmet-async";

const STEPS = [
  {
    title: "Start your return",
    text: "Contact us with your order number and the items you want to send back.",
  },
  {
    title: "Pack the items",
    text: "Include everything that came with the item, in its original packaging where possible.",
  },
  {
    title: "Send it back",
    text: "Drop it at a store or use the return label we email you.",
  },
  {
    title: "Get your refund",
    text: "We refund you within 7 business days of receiving the items.",
  },
];

function Returnspolicy() {
  return (
    <InfoPage
      title="Returns"
      intro="Changed your mind or got the wrong item? You can return most products within 7 days of delivery."
    >
      <Helmet>
        <title>Returns & Refunds | Ninety One Streetwear Store, Kenya</title>
        <meta
          name="description"
          content="Return unused Ninety One items within 7 days of delivery. See how to start a return, what we accept, and when your refund or exchange arrives."
        />
        <link rel="canonical" href="https://ninetyone.co.ke/return-policy" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "HowTo",
            name: "How to return an item to Ninety One",
            step: STEPS.map((s, i) => ({
              "@type": "HowToStep",
              position: i + 1,
              name: s.title,
              text: s.text,
            })),
          })}
        </script>
      </Helmet>
      <section className="info-section">
        <h2 className="info-h2">How to return an item</h2>
        <ol className="info-steps">
          {STEPS.map((s, i) => (
            <li key={s.title} className="info-step">
              <span className="info-step-num">{i + 1}</span>
              <div>
                <h3 className="info-h3">{s.title}</h3>
                <p>{s.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section className="info-section info-grid info-grid--2">
        <div className="info-item">
          <h3 className="info-h3">What you can return</h3>
          <ul className="info-list">
            <li>Unused items in their original condition</li>
            <li>Items with tags and packaging intact</li>
            <li>Different size or colour from what you ordered</li>
          </ul>
        </div>
        <div className="info-item">
          <h3 className="info-h3">What we can't take back</h3>
          <ul className="info-list">
            <li>Used or washed items</li>
            <li>Gift cards</li>
            <li>Items marked final sale</li>
          </ul>
        </div>
      </section>

      <section className="info-section">
        <h2 className="info-h2">Refunds and exchanges</h2>
        <p className="info-text">
          Refunds go back to your store credit. Want a different size or colour
          instead? Tell us when you start the return and we'll set up an
          exchange.
        </p>
        <div className="info-actions">
          <Link to="/contact-us" className="info-btn info-btn--primary">
            Start a return
          </Link>
          <Link to="/faqs" className="info-btn info-btn--secondary">
            Read the FAQs
          </Link>
        </div>
      </section>
    </InfoPage>
  );
}

export default Returnspolicy;
